import Device from "../../devices/device";
import DeviceStorage from "../../components/DeviceStorage/DeviceStorage";
import NewRelic from "../trackers/NewRelic";
import getAppConfig from '../../config/appConfig';
import storage from '../../components/DeviceStorage/DeviceStorage';
import logger from '../logger/logger';


export const TIMEOUT = 'timeout';
export const CRASH = 'crash';
export const RENDER_FAILURE = 'render_failure';
export const DATA_LOAD_FAILURE = 'data_load_failure';
export const PROFILES = 'profiles';
export const LANDING_NEWRELIC = 'landing';
export const HOMEUSER = 'homeuser';
export const HOME_CAROUSEL = 'home_carousel';

const errorTypes = {
  [TIMEOUT] : TIMEOUT,
  [CRASH]: CRASH,
  [RENDER_FAILURE]: RENDER_FAILURE,
  [DATA_LOAD_FAILURE]: DATA_LOAD_FAILURE
}

const  generateUUID = (currentChar) => {
  const randomHexDigit = (Math.random() * 16) | 0;
  const finalHexValue = currentChar === 'x' ? randomHexDigit : (randomHexDigit & 0x3) | 0x8;
  return finalHexValue.toString(16);
}

const getUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(
      /[xy]/g,
      function (currentChar) { return generateUUID(currentChar) } );
}

const getAppStartTime = () => {
  const appStartTimeStorage = DeviceStorage.getItem("appStartTime");
  return appStartTimeStorage && typeof appStartTimeStorage === 'string'
    ? parseInt(appStartTimeStorage)
    : 0;
}

const initializeAppStart = () => {
  return DeviceStorage.getItem("appStart") || "false";
}

const getRegion = () => {
  return DeviceStorage.getItem("region") || 'n/a'
}

const finishAppStartupMetric = (attributes, userToken, appStart) => {
    appStart === 'true' && logAppStartupSessionLifecycleNewRelic(attributes, userToken);
    localStorage.setItem("appStart", "false");
};

export const sendLoadAppToNewRelic = (display = null) => {
  const userToken = localStorage.getItem('user_token') || '';
  const appStartTime = getAppStartTime();
  const appStart = initializeAppStart();
  const attributesNewRelicOk = {
  eventName:"AppStartupMetrics",
  }

  attributesNewRelicOk.userInteractionReady = Date.now() - appStartTime;
    finishAppStartupMetric(attributesNewRelicOk, userToken, appStart);
};

export const sendLoadAppErrorToNewRelic = (errorType = null) => {
  const userToken = localStorage.getItem('user_token') || '';
  const attributesNewRelicError = {
  eventName:"AppStartupMetricsError",
  }

  attributesNewRelicError.errorType = errorType ? errorTypes[errorType] : 'n/a';
  const appStart = initializeAppStart();
    finishAppStartupMetric(attributesNewRelicError, userToken, appStart);

};

const getLaunchSource = () => {
    const navigation = window.performance && window.performance.navigation;

    if (navigation && (navigation.type === 1 || navigation.type === 2)) {
        return 'resume';
    }

    if (window.location.pathname !== '/' && !document.referrer) {
        return 'deeplink';
    }

    return 'cold_start';
};

const getHeader = (headers, name) => {
    if (!headers) return '';
    if (typeof headers.get === 'function') return headers.get(name) || '';
    return headers[name] || headers[name.toLowerCase()] || '';
};

const getSafeHeaders = (headers) => {
    const names = ['content-type', 'server', 'via', 'x-cache', 'content-length', 'retry-after', 'date'];
    return names.map((name) => {
        const value = getHeader(headers, name);
        return value ? `${name}:${value}` : '';
    }).filter(Boolean).join(',');
};

const redactRawBody = (rawBody) => {
    if (typeof rawBody !== 'string') return rawBody;

    const redact = (key, value) => /^(user_token|access_token|refresh_token|token_wap|authorization)$/i.test(key)
        ? '[REDACTED]'
        : value;

    try {
        return JSON.stringify(JSON.parse(rawBody), redact);
    } catch (error) {
        return rawBody.replace(
            /("(?:user_token|access_token|refresh_token|token_wap|authorization)"\s*:\s*")[^"]*(")/gi,
            '$1[REDACTED]$2'
        );
    }
};

const stringifyRedactedResponse = (response) => JSON.stringify(response, (key, value) => {
    return /^(user_token|access_token|refresh_token|token_wap|authorization)$/i.test(key)
        ? '[REDACTED]'
        : value;
});

const decodeUserToken = (token) => {
    try {
        if (!token || typeof token !== 'string') return null;
        const parts = token.split('.');
        if (parts.length < 2) return null;
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
        const jsonString = typeof window !== 'undefined' && typeof window.atob === 'function'
            ? window.atob(padded)
            : (typeof Buffer !== 'undefined' ? Buffer.from(padded, 'base64').toString('utf8') : null);
        if (!jsonString) return null;
        return JSON.parse(jsonString);
    } catch (e) {
        return null;
    }
};

const getUserDataFromToken = (token) => {
    const payload = decodeUserToken(token);
    if (!payload) return { userType: null, userId: null };
    const usr = payload.usr || {};
    const userType = usr.user_type || usr.userType || payload.user_type || payload.userType || null;
    const userId = usr.user_id !== null && usr.user_id !== undefined
        ? String(usr.user_id)
        : (payload.user_id !== null && payload.user_id !== undefined ? String(payload.user_id) : null);
    return { userType, userId };
};

const classifyError = (session, response, status, errorCode, detail, isJson, contentType) => {
    const errorTags = [];
    const rawBody = response.rawBody !== undefined
        ? redactRawBody(response.rawBody)
        : typeof response.body === 'string'
          ? response.body
          : response.errors ? stringifyRedactedResponse(response) : null;
    const bodyText = `${rawBody} ${detail || ''}`;
    const abortReason = session.abortReason || response.abortReason || 'n/a';
    const attempt = Number(session.attempt || 1);
    const nullFields = response.nullFields || session.nullFields;
    let errorType;

    if (response.status !== undefined && status !== 0 && response.responseContentType &&
        response.responseContentType !== 'unknown' && !isJson) {
        errorType = 'unexpected_content_type';
        errorTags.push('content_type_mismatch');
        if (contentType === 'text/html') errorTags.push('html_error_page');
    } else if (response.emptyResponse || response.contentLength === 0 || rawBody === '') {
        errorType = 'empty_response';
    } else if (response.malformedJson) {
        errorType = 'malformed_json';
    } else if (status === 0 && ['page_unload', 'navigation_away'].includes(abortReason) &&
        (session.obsoleteRoute || response.obsoleteRoute)) {
        errorType = 'obsolete_route_request';
        errorTags.push('obsolete_route');
    } else if (status === 0 && ['page_unload', 'navigation_away', 'client_abort'].includes(abortReason)) {
        errorType = 'client_aborted';
    } else if (status === 0 && ['network_offline', 'dns_tls_error'].includes(abortReason)) {
        errorType = 'network_lost';
    } else if (status === 0 && abortReason === 'client_timeout') {
        errorType = 'client_timeout';
    } else if (status === 400 && storage.getItem("HKS") && storage.getItem('user_id')) {
        errorType = 'session_not_found';
    } else if (status === 401 || status === 403  || errorCode === 'USR_JWT_00001' || errorCode === 'USR_JWT_00002') {
        if (session.flowStep === 'refreshToken') {
            errorType = 'refresh_unauthorized_token';
        } else if (errorCode === 'USR_JWT_00002') {
            errorType = 'token_expired';
        } else {
            errorType = 'invalid_token';
        }
    } else if (status === 200 && /request timed out/i.test(bodyText)) {
        errorType = 'dependency_timeout';
        if (/geolocation/i.test(bodyText)) errorTags.push('dep_geolocation_timeout');
        if (/metadata/i.test(bodyText)) errorTags.push('dep_metadata_timeout');
        if (errorTags.length === 0) errorTags.push('dep_other_timeout');
    } else if (status === 200 && nullFields) {
        errorType = 'null_fields';
        (Array.isArray(nullFields) ? nullFields : [nullFields]).slice(0, 5).forEach((field) => {
            errorTags.push(`null_${String(field).replace(/[^a-z0-9]+/gi, '_').toLowerCase()}`);
        });
    } else if (status >= 500 && contentType === 'application/json') {
        errorType = 'backend_error';
    } else if (session.recurrentError && attempt > 3) {
        errorType = 'backend_error';
        errorTags.push('recurring');
    } else if (session.errorType === 'token_expired' && status < 0) {
        errorType = 'token_expired';
    } else {
        errorType = 'n/a';
        errorTags.push('unclassified');
    }

    return { errorType, errorTags, rawBody };
};

const region = getRegion();
const traceId = getUUID();
const platform = Device.getDevice().getPlatform();
const appConfig = typeof getAppConfig === 'function' ? getAppConfig() || {} : {};

const DEFAULT_SESSION_LIFECYCLE_ATTRIBUTES = {
    // 1. Contrato
    eventType: 'SessionLifecycleEvent',
    schemaVersion: '2.1',

    // 2. Qué pasó
    eventName: 'n/a',
    success: 'false',
    errorType: 'n/a',
    errorCode: 'n/a',
    backendCode: -1,
    errorTags: 'n/a',
    errorDetail: 'n/a',

    // 3. Respuesta cruda
    responseContentType: 'unknown',
    responseHeaders: 'n/a',

    // 4. Dónde y cuándo
    flowStep: 'n/a',
    endpoint: 'n/a',
    httpStatus: -1,
    durationMs: -1,
    abortReason: 'n/a',
    attempt: 1,

    // 5. Ruteo y región
    region: region || 'n/a',

    // 6. Cliente
    platform: platform || 'n/a',
    runtimeType: 'browser',
    appVersion: process.env.REACT_APP_VERSION || 'n/a',
    appBuild: process.env.REACT_APP_VERSION || 'n/a',
    deviceBrand: appConfig.device_manufacturer || 'n/a',
    deviceOS: appConfig.device_so || 'n/a',

    // 7. Sesión y usuario
    traceId: traceId || 'n/a',
    deviceInstallId: appConfig.device_id || 'n/a',
    userId: 'n/a',
    userType: 'n/a',
    viewContext: window.location.pathname || 'n/a',
    launchSource: getLaunchSource(),
    appState: document.visibilityState === 'visible' ? 'foreground' : 'background',
};

export const logSessionLifecycleNewRelic = (newAttributes = {}, response = {}, previousUserToken = '') => {
    const session = newAttributes || {};
    const errorCode = (Array.isArray(response.errors)
        ? response.errors[0] && response.errors[0].code
        : response.errors && response.errors.code) || response.code ||
        (response.error && response.error.code) || 'n/a';
    const status = response.httpStatus !== undefined && response.httpStatus !== 0
        ? Number(response.httpStatus)
        : (response.status === 0 ? 0 : Number(response.status || -1));
    const responseContentType = response.responseContentType || getHeader(response.headers, 'content-type') || 'unknown';
    const rawContentType = responseContentType.toLowerCase().split(';')[0].trim();
    const isJson = rawContentType === 'application/json' || rawContentType === 'text/json';
    const contentType = isJson ? 'application/json' : rawContentType;
    const contentTypeValues = ['application/json', 'text/html', 'text/plain', 'text/xml'];
    const normalizedContentType = isJson
        ? 'application/json'
        : (contentTypeValues.includes(contentType)
            ? contentType
            : (contentType === '' && (response.emptyResponse || response.contentLength === 0)
                ? 'empty'
                : 'unknown'));
    const errorDetail = (Array.isArray(response.errors)
        ? response.errors[0] && (
            response.errors[0].detail || response.errors[0].message || response.errors[0].msg || response.errors[0].description
        )
        : response.errors && (
            response.errors.detail || response.errors.message || response.errors.msg || response.errors.description
        )) || (response.error && (
        response.error.detail || response.error.message || response.error.msg || response.error.description
    )) || response.message || '';
    const classification = classifyError(session, response, status, errorCode, errorDetail, isJson, contentType);
    const tokenData = getUserDataFromToken(previousUserToken);
    const isLoginSuccess = session.eventName === 'loginSuccess' && status === 200;

    const attributes = {
        ...DEFAULT_SESSION_LIFECYCLE_ATTRIBUTES,
        eventName: session.eventName || 'n/a',
        success: isLoginSuccess ? 'true' : 'false',
        errorType: isLoginSuccess ? 'n/a' : classification.errorType,
        errorCode: isLoginSuccess ? 'n/a' : errorCode,
        backendCode: isLoginSuccess ? -1 : (response.backendCode !== undefined
                ? response.backendCode
                : (response.backend_code !== undefined
                    ? response.backend_code
                    : (typeof response.code === 'number'
                        ? response.code
                        : (response.errors && typeof response.errors.code === 'number' ? response.errors.code : -1)))),
        errorTags: isLoginSuccess ? 'n/a' : [...classification.errorTags, ...(session.errorTags ? session.errorTags.split(',') : [])].join(',') || 'n/a',
        errorDetail: isLoginSuccess
            ? 'n/a'
            : classification.errorType === 'n/a'
            ? classification.rawBody || errorDetail || 'n/a'
            : errorDetail || 'n/a',
        responseContentType: normalizedContentType,
        responseHeaders: response.responseHeaders || getSafeHeaders(response.headers) || 'n/a',
        flowStep: session.flowStep || 'isLoggedIn',
        endpoint: response.endpoint || 'n/a',
        httpStatus: status,
        durationMs: (response.durationMs !== undefined ? response.durationMs : -1),
        abortReason:  response.abortReason || 'n/a',
        attempt: 1,
        userId: tokenData.userId || 'n/a',
        userType: tokenData.userType || 'n/a',

    };

    const enums = {
        success: ['true', 'false'],
        responseContentType: ['application/json', 'text/html', 'text/plain', 'text/xml', 'empty', 'unknown'],
        errorTags: [
            'content_type_mismatch', 'html_error_page', 'dep_geolocation_timeout',
            'dep_metadata_timeout', 'dep_other_timeout', 'null_region', 'null_date',
            'null_timezone', 'malformed_json', 'truncated_body', 'unclassified',
            'during_playback', 'recovered_silently', 'reauth_required',
            'obsolete_route', 'recurring',
        ],
        abortReason: [
            'dns_tls_error',
            'cors_blocked',
            'page_unload',
            'navigation_away',
            'client_abort',
            'network_offline',
            'client_timeout',
            'unknown',
            'n/a',
        ],
    };

    const numericFields = ['backendCode', 'httpStatus', 'durationMs', 'attempt'];

    Object.keys(attributes).forEach((key) => {
        if (key === 'eventType') return;

        const incoming = key === 'errorType' ? attributes.errorType : session[key];
        const hasIncoming =
            incoming !== null &&
            incoming !== undefined &&
            !(typeof incoming === 'string' && incoming.trim() === '');

        let value = hasIncoming ? incoming : attributes[key];

        if (numericFields.includes(key)) {
            value = value === null || value === undefined || value === '' ? -1 : Number(value);

            const minimum = key === 'attempt' ? 1 : -1;

            attributes[key] =
                Number.isFinite(value) && Math.floor(value) === value && value >= minimum
                    ? value
                    : key === 'attempt'
                      ? 1
                      : -1;
        } else {
            value = value === null || value === undefined ? 'n/a' : String(value).trim();

            if (key !== 'errorTags' && enums[key] && !enums[key].includes(value)) {
                value = enums[key].includes(attributes[key]) ? attributes[key] : 'n/a';
            }

            const maxLength = key === 'errorDetail' && attributes.errorType === 'n/a' ? 4096 : 255;
            attributes[key] = String(value || 'n/a').slice(0, maxLength);
        }
    });

    if (attributes.httpStatus !== 0) {
        attributes.abortReason = 'n/a';
    }

    if (attributes.endpoint !== 'n/a') {
        const cleanEndpoint = attributes.endpoint
            .replace(/^https?:\/\/[^/]+/i, '')
            .split(/[?#]/)[0];
        attributes.endpoint = cleanEndpoint
            ? (cleanEndpoint.startsWith('/') ? cleanEndpoint : `/${cleanEndpoint}`).slice(0, 255)
            : 'n/a';
    }

    if (attributes.errorTags !== 'n/a') {
        attributes.errorTags =
            attributes.errorTags
                .split(',')
                .map((tag) => tag.trim())
                .filter((tag) => enums.errorTags.includes(tag))
                .slice(0, 5)
                .join(',') || 'n/a';
    }

    const allowedHeaders = [
        'content-type',
        'server',
        'via',
        'x-cache',
        'content-length',
        'retry-after',
        'date',
    ];
    if (attributes.responseHeaders !== 'n/a') {
        attributes.responseHeaders =
            attributes.responseHeaders
                .split(/,(?=\s*[a-zA-Z-]+\s*:)/)
                .map((header) => {
                    const separator = header.indexOf(':');
                    if (separator <= 0) return '';
                    const name = header.slice(0, separator).trim().toLowerCase();
                    return allowedHeaders.includes(name)
                        ? `${name}:${header.slice(separator + 1).trim()}`
                        : '';
                })
                .filter(Boolean)
                .join(',')
                .slice(0, 255) || 'n/a';
    }

    recordSessionLifecycleEvent(attributes);

    return attributes;
};

const recordSessionLifecycleEvent = (attributes) => {
    try {
        if (NewRelic && NewRelic.recordCustomEvent) {
            NewRelic.recordCustomEvent('SessionLifecycleEvent', attributes);
        }
    } catch (error) {
        logger.error('NewRelic event SessionLifecycleEvent error', error);
    }
};

const logAppStartupSessionLifecycleNewRelic = (startupAttributes = {}, previousUserToken) => {
    const tokenData = getUserDataFromToken(previousUserToken);
    const attributes = {
        ...DEFAULT_SESSION_LIFECYCLE_ATTRIBUTES,
        eventName: startupAttributes.eventName,
        success: startupAttributes.eventName === 'AppStartupMetrics' ? 'true' : 'false',
        errorType: startupAttributes.errorType || 'n/a',
        flowStep: 'appStartup',
        durationMs: Number(startupAttributes.userInteractionReady) || -1,
        userId: tokenData.userId || 'n/a',
        userType: tokenData.userType || 'n/a',
    };
        recordSessionLifecycleEvent(attributes);
    return attributes;
};


// WEBPACK FOOTER //
// ./src/utils/newRelic_loadApp/newRelic-load-app.js